import { useBatchReveal } from "../animations/hooks";
import TitleHeading from "./TitleHeading";

function NineImagesWithDescription(props) {
    const data = props?.data;
    const title = props?.title;
    const gridRef = useBatchReveal({ stagger: 0.08, y: 28 }, [data?.length]);

    if(data)
    return (
        <section className="portfolio-block projects compact-grid">
            <TitleHeading
            title = {title}
            className = "text-center pb-4"
            />
            <div className="row g-0" ref={gridRef}>
                {
                    data && data.map((item, index) => (
                        <div className="col-md-6 col-lg-4 item zoom-on-hover position-relative" data-reveal key={item?.id || index}>
                            <a>
                                <img className="img-fluid image" src={item?.img} alt={item?.title} />
                                <span className="description">
                                    <span className="description-heading">{item?.title}</span>
                                    <span className="description-body">{item?.description}</span>
                                </span>
                            </a>
                        </div>
                    ))
                }
            </div>
        </section>
    )
}
export default NineImagesWithDescription;